/**
 * Handles all media related utlities and filters
 */
var MediaUtils = new function() {
    var self = this;

    var _isUserProfileImagesHidden = false,
        currentUserId;

    publicConfiguration = (typeof(window) == 'undefined')? require("../config/public.conf.js"): publicConfiguration;
    Utils = (typeof(window) == 'undefined')? require("./util.js"): window.Utils;

    var imageSizes = {
        "_cover_brand_small": {"normal": "_240_240", retina: "_240_240"},
        "_cover_brand": {"normal": "_800_450", retina: "_800_450"},
        "_cover_brand_large": {"normal": "_2400_1350", retina: "_2400_1350"},
        "_icon_user_search": {"normal": "_240_240", retina: "_240_240"},
        "_cover_job_search": {"normal": "_800_450", retina: "_800_450"},
        "_cover_brand_search": {"normal": "_480_320", retina: "_800_450"},
        "_icon_brand_search": {"normal": "_120_120", retina: "_240_240"},
        "_background_user_profile": {"normal": "_2400_1350", retina: "_2400_1350"},
        "_cover_user_profile": {"normal": "_800_450", retina: "_800_450"},
        "_icon_user_profile": {"normal": "_240_240", retina: "_640_640"},
        "_image_profile_full": {"normal": "_640_640", retina: "_640_640"},
        "_background_brand_profile": {"normal": "_2400_1350", retina: "_2400_1350"},
        "_cover_brand_profile": {"normal": "_800_450", retina: "_800_450"},
        "_carri_conversation_image": {"normal": "_800_450", retina: "_800_450"},
        "_icon_brand_profile": {"normal": "_240_240", retina: "_240_240"},
        "_header_brand_profile": {"normal": "_240_240", retina: "_240_240"},
        "_icon_brand_job_profile": {"normal": "_80_80", retina: "_240_240"},
        "_cover_brand_job_profile": {"normal": "_800_450", retina: "_800_450"},
        "_icon_brand_small_profile": {"normal": "_40_40", retina: "_80_80"},
        "_media_thumbnail_large": {"normal": "_1280_1280", retina: "_1280_1280"},
        "_media_thumbnail_small": {"normal": "_320_180", retina: "_320_180"},
        "_media_image": {"normal": "_1280_1280", retina: "_1280_1280"},
        "_icon_user_ams_card": {"normal": "_120_120", retina: "_240_240"},
        "_brand_ams_icon": {"normal": "_80_80", retina: "_120_120"},
        "_icon_user_candidate_card": {"normal": "_240_240", retina: "_240_240"},
        "_cover_user_candidate_card": {"normal": "_800_450", retina: "_800_450"},
        "_icon_user_chat": {"normal": "_80_80", retina: "_80_80"},
        "_icon_brand_chat": {"normal": "_80_80", retina: "_80_80"},
        "_cover_brand_appbg": {"normal": "_800_450", retina: "_800_450"},
        "_cover_brand_application_widget": {"normal": "_800_450", retina: "_800_450"},
        "_icon_brand_application_widget": {"normal": "_80_80", retina: "_120_120"},
        "_icon_user_dashboard_main": {"normal": "_80_80", retina: "_240_240"},
        "_icon_brand_dashboard_main": {"normal": "_240_240", retina: "_240_240"},
        "_icon_brand_registration": {"normal": "_240_240", retina: "_240_240"},
        "_header_rectangle_image": {"normal": "_250_50", retina: "_250_50"},
        "_cover_brand_registration": {"normal": "_800_450", retina: "_800_450"},
        "_header_brand_registration": {"normal": "_240_240", retina: "_240_240"},
        "_icon_user_registration": {"normal": "_800_450", retina: "_800_450"},
        "_cover_brand_work_history": {"normal": "_800_450", retina: "_800_450"},
        "_cover_user_user_media": {"normal": "_800_450", retina: "_800_450"},
        "_icon_user_user_media": {"normal": "_240_240", retina: "_240_240"},
        "_media_thumbnail_user_media": {"normal": "_320_180", retina: "_240_240"},
        "_media_thumbnail_brand": {"normal": "_320_180", retina: "_320_180"},
        "_media_thumbnail_user": {"normal": "_320_180", retina: "_320_180"},
        "_cover_user_registration": {"normal": "_800_450", retina: "_800_450"},
        "_cover_course_image": {"normal": "_300_300", retina: "_600_600"},
        "default": "big"
    };

	//Define media environments
	var mediaEnvs = [
		{
			prefix: 'h',
			env: 'HARRI_MEDIA_SERVERS'
		},
		{
			prefix: 't',
			env: 'TEAM_MEDIA_SERVERS'
		},
        {
            prefix: 'tc',
            env: 'TEAM_COMMUNICATION_SERVERS'
        }
	];

	//define media filters
    var mediaFilters = [
        {
            name: 'MediaURL',
            action: function (mediaEnv) {
                return function (media, type, sizeCode) {
                    type = type || 'brand';
                    if (!sizeCode) {
                        if (type.indexOf('user_profile') > -1) {
                            sizeCode = '_icon_user_search'
                        } else if (type.indexOf('cover') > -1) {
                            sizeCode = '_cover_brand'
                        } else if (type.indexOf('brand') >= 0) {
                            sizeCode = '_icon_brand_profile';
                        } else if (type.indexOf('carri') >= 0) {
                            sizeCode = '_carri_conversation_image';
                        } else {
                            sizeCode = '_icon_brand_profile';
                        }
                    }
                    return MediaUtils.getImageFromPath(media, type, sizeCode, mediaEnv);
                }
            }
        },
        {
            name: 'UserProfileImage',
            action: function(mediaEnv) {
				return function(ids, sizeCode, returnAsString, defaultImage, extension) {
					var type = 'user_profile';
					sizeCode = sizeCode || '_icon_user_search';

					return MediaUtils.getImagePath(ids[0], ids[1], !returnAsString, sizeCode, type, extension, defaultImage, mediaEnv);
				}
			}
        },
        {
            name: 'UserCoverImage',
            action: function(mediaEnv) {
				return function(ids, sizeCode, returnAsString, defaultImage, extension) {

					var type = 'user_background';
					sizeCode = sizeCode || '_cover_user_profile';

					return MediaUtils.getImagePath(ids[0], ids[1], !returnAsString, sizeCode, type, extension, defaultImage, mediaEnv);
				}
			}
        },
        {
            name: 'UserCoverBlurred',
            action: function(mediaEnv) {

				return function(uuid, sizeText) {

					var type = 'user_photo';
					sizeText = sizeText || '_800_450';
					sizeText = 'blurred' + sizeText;

					var imageString = 'images/default_user_cover.jpg';

					if (uuid && !_isUserProfileImagesHidden) {
						imageString = publicConfiguration.getBaseAPI() + type + '/' + sizeText + '/' + uuid;
					}

					return 'background-image: url(' + imageString + ')';

				}
			}
        },
        {
            name: 'BrandIconImage',
            action: function(mediaEnv) {

				return function(ids, sizeCode, returnAsString, defaultImage, extension) {
					var type = 'brand_profile';
					sizeCode = sizeCode || '_icon_brand_profile';
                    if (ids[2]) {
                        if (!returnAsString) {
                            return 'background-image: url(' + ids[2] + ')';
                        }
                        return ids[2];
                    }

					return MediaUtils.getImagePath(ids[0], ids[1], !returnAsString, sizeCode, type, extension, defaultImage, mediaEnv);
				}
			}
        },
        {
            name: 'BrandCoverImage',
            action: function(mediaEnv) {

				return function(ids, sizeCode, returnAsString, defaultImage, extension) {
					var type = 'brand_background';
					sizeCode = sizeCode || '_cover_brand';

					if (ids[2]) {
                        if (!returnAsString) {
                            return 'background-image: url(' + ids[2] + ')';
                        }
                        return ids[2];
                    }

					return MediaUtils.getImagePath(ids[0], ids[1], !returnAsString, sizeCode, type, extension, defaultImage, mediaEnv);
				}
			}
        },
        {
            name: 'BrandHeaderImage',
            action: function(mediaEnv) {

                return function(ids, sizeCode, returnAsString, defaultImage, extension) {
                    var type = 'brand_offer_header';
                    sizeCode = sizeCode || 'default';

                    return MediaUtils.getImagePath(ids[0], ids[1], !returnAsString, sizeCode, type, extension, defaultImage, mediaEnv);
                }
            }
        },
        {
            name: 'BrandCoverBlurred',
            action: function(mediaEnv) {

				return function(uuid, sizeText) {

					var type = 'brand_file';
					sizeText = sizeText || '_800_450';
					sizeText = 'blurred' + sizeText;

					var imageString = 'images/default_blur_cover_image.jpg';

					if (uuid) {
						imageString = publicConfiguration.getBaseAPI() + type + '/' + sizeText + '/' + uuid;
					}

					return 'background-image: url(' + imageString + ')';
				}
			}
        },
        {
            name: 'BrandGalleryThumb',
            action: function(mediaEnv) {

				return function (params, sizeCode, returnAsStyle, defaultImage, extension) {
					var mediaUUID = params[0];
					var identifier = params[1];
					var mediaType = params[2];
					var videoDomain = params[3];

					if (mediaType && mediaType.indexOf("image") >= 0) {
						sizeCode = sizeCode || '_media_thumbnail_brand';
						return MediaUtils.getImagePath(mediaUUID, identifier, returnAsStyle, sizeCode, 'brand_gallery', extension, defaultImage, mediaEnv);
					}
					else if (mediaType && mediaType.indexOf("video") >= 0) {
                        if (videoDomain) {
                            identifier = videoDomain + identifier;
                        } else {
                            var videoObj = self.parseVideoURL(identifier);
                            if (!videoObj.type) {
                                identifier = publicConfiguration.getTranscodedMediaServer() + identifier + mediaUUID + '/';
                            }
                        }
                        return MediaUtils.getVideoThumb(mediaUUID, identifier, returnAsStyle, sizeCode);
                    } else if (mediaType && mediaType.indexOf("THUMBNAIL") >= 0) {
                        sizeCode = sizeCode || '_icon_user_user_media';
                        return MediaUtils.getImagePath(mediaUUID, identifier, returnAsStyle, sizeCode, mediaType, extension, defaultImage, mediaEnv);
                    }
				}
			}
        },
        {
            name: 'UserGalleryThumb',
            action: function(mediaEnv) {

				return function(params, sizeCode, returnAsStyle, defaultImage, extension) {
					var mediaUUID = params[0];
					var identifier = params[1];
					var mediaType = params[2];
					var videoDomain = params[3];

					if (mediaType && mediaType.indexOf("image") >= 0) {
						sizeCode = sizeCode || '_media_thumbnail_user';
						return MediaUtils.getImagePath(mediaUUID, identifier, returnAsStyle, sizeCode, 'user_gallery', extension, defaultImage, mediaEnv);
					}
					else if (mediaType && mediaType.indexOf("video") >= 0) {

						if (videoDomain) {
							identifier = videoDomain + identifier;
						}
						return MediaUtils.getVideoThumb(mediaUUID, identifier, returnAsStyle, sizeCode);
					}
				}
			}
        },
        {
            name: 'MarketingBrandImage',
            action: function(mediaEnv) {

				return function(params, defaultType, returnAsString) {
					var imageUUID = params[0];
					var imagePath = params[1];
					var mediaServer = params[2];
					var extension = params[3];

					var imageString = '';
					var defaultType = defaultType || 'icon';

					if (imageUUID) {

						if (!imagePath || !mediaServer || !extension) {
							console.error("Invalid params for marketing brand image given, imagePath:", imagePath, " mediaServer:", mediaServer, " extension:", extension);
						}

						imageString = mediaServer + imagePath + '/' + imageUUID + '/image.' + extension;
					}
					else {
						switch (defaultType) {
							case 'icon':
								imageString = 'images/default_brand_600.png';
								break;
							case 'cover':
								imageString = 'images/default_cover_image.jpg';
								break;
							case 'carri':
								imageString = '/images/carri/carri-chatbot-logo.png';
								break;
						}
					}

					if (!returnAsString) {
						imageString = 'background-image: url(' + imageString + ')';
					}

					return imageString;
				}
			}
        },
        {
            name: 'VideoLink',
            action: function(mediaEnv) {
				return function(params, quality, extension, ignoreTranscoded) {
					var uuid = params[0];
					var applicationId = params[1];
                    var path = params[2];
                    var href = params[3];

					quality = quality || '480P';
					extension = extension || 'mp4';

					if (href) {
					    return href;
                    }

                    if (!uuid || (!applicationId && !path)) {
                        console.warn("Missing data for hVideoLink");
                        return '';
                    }

                    var baseServer = publicConfiguration.getTranscodedMediaServer();

                    if (ignoreTranscoded) {
                        baseServer = publicConfiguration.getMediaServer();
                    }

                    if (!path) {
                        path = 'applications/' + applicationId + '/videos/' + uuid + '/';
                    }

                    return baseServer + path + quality + '.' + extension;
				}
			}
        },
        {
            name: 'ResumeURL',
            action: function(mediaEnv) {
                return function(params, extension, viewer, embedded) {
                    extension = extension || 'pdf';
                    var href = params[0];
                    if (viewer && (extension.toLowerCase().indexOf("doc") === 0 || extension.toLowerCase().indexOf("docx") === 0) || extension.toLowerCase().indexOf("rtf") === 0) {
                        if (extension.toLowerCase().indexOf("rtf") === 0) {
                            href = "https://docs.google.com/gview?url=" + encodeURIComponent(href);
                        } else {
                            href = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(href);
                        }
                        if (embedded) {
                            href += "&embedded=true";
                        }
                    }
                    return href;
                }
			}
        },
        {
            name: 'ProfileToPdf',
            action: function(mediaEnv) {
				return function(params) {
					var userId = params[0];
					var baseApi = publicConfiguration.getBaseAPI();

					return baseApi + "candidate/profile_download/" + userId + "?force_download=true";
				}
			}
        },
        {
            name: 'JobBoardsLogo',
            action: function(mediaEnv) {

				return function (params, extension) {
					var uuid = params[0];
					var boardCode = params[1];
					var extension = extension || 'png';

					if (boardCode == "HARRI") {
						return "../images/logos/harri/blue/logo.svg";
					}

					var mediaServer = getMediaUrl(mediaEnv);

					return mediaServer + "job_boards/" + boardCode + "/" + uuid + "/logo." + extension;
				}
			}
        },
        {
            name: 'CommunicationImage',
            action: function (mediaEnv) {

                return function (params, type, imageSize, extension) {
                    var uuid = params[0];
                    var href = params[1];
                    var brandId = params[2];
                    var id = params[3];

                    var hrefImageSize;
                    var tempArray = href.split(uuid + '/');
                    tempArray && tempArray[1] && (hrefImageSize = tempArray[1].split('.' + extension)[0]);

                    if (hrefImageSize === imageSize) {
                        return href;
                    } else {
                        var fileName = imageSize + '.' + extension;
                        if (type === 'message') {
                            return publicConfiguration.TSTeamCommunicationServerBaseURL + "brands/" + brandId + "/messages/" + id + "/image/" + uuid + "/" + fileName;
                        } else if (type === 'post') {
                            return publicConfiguration.TSTeamCommunicationServerBaseURL + "brands/" + brandId + "/posts/" + id + "/image/" + uuid + "/" + fileName;
                        }
                    }
                }
            }
        }
    ];

    /**
     * Change size key to a size value from configuration
     */
    var getSize = function(key) {
        var sizeResult;

        if (!imageSizes[key]) {
            sizeResult = imageSizes['default'];
        }
        else {
            sizeResult = (Utils.isRetinaScreen() && imageSizes[key].retina)? imageSizes[key].retina: imageSizes[key].normal;
        }

        return sizeResult.substr(1);
    };

    /**
     * Parse external video into video obj, type and id (e.g. youtube, vimeo)
     */
    self.parseVideoURL = function(url) {

        var result = {};

        if (url.match('(www.)?youtube|youtu\.be')) {
            result.type = 'youtube';

            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            if (match && match[7].length == 11){
                result.id = match[7];
            }
        }
        else if (url.match('(player.)?vimeo\.com')) {
            var regExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
            var match = url.match(regExp);
            result.type  = "vimeo";
            result.id    = match[3];
        }

        return result;
    };

    /**
     * Get external video thumbnail (vimeo, youtube)
     */
    var getExternalVideoThumb = function(type, id) {
        var thumb;

        switch (type) {
            case 'youtube':
                var jpgExt = 'jpg';
                thumb = 'https://img.youtube.com/vi/' + id + '/' + ['0', jpgExt].join(".");
                break;

            case 'vimeo':
                var jsonExt = 'json';
                try {
                    $.ajax({
                        url: 'https://vimeo.com/api/v2/video/' + id + '.' + jsonExt,
                        success: function(result) {
                            thumb = result && result[0] && result[0].thumbnail_large;
                        },
                        async: false
                    });
                }
                catch (e) {
                    console.warn("Failed to vimeo video thumbnail");
                }
                break;
        }

        return thumb;
    };

	/**
	 * Get media server URL based on env
	 *
	 * @param mediaEnv
	 * @returns {*}
	 */
	var getMediaUrl = function (mediaEnv) {
        switch (mediaEnv) {
            case 'TEAM_MEDIA_SERVERS':
                return publicConfiguration.getTeamMediaServer();
            case 'HARRI_MEDIA_SERVERS':
                return publicConfiguration.getMediaServer();
            case 'TEAM_COMMUNICATION_SERVERS':
                return publicConfiguration.getTeamCommunicationMediaServer();
        }

        return publicConfiguration.getMediaServer();
	};


    /**
     * Register filters for Angular and Nunjucks
     * @param environment
     */
    self.registerFilters = function(environment) {
        var envType;
        var addFilterFunc;

        if (typeof(environment.addFilter) == 'function') {
            envType = 'nunjucks';
        }
        else if (typeof(environment.filter) == 'function') {
            envType = 'angular';
            addFilterFunc = environment.filter;
        }

        if (!envType) {
            throw("Media Utils: Unsupported environment given", environment);
        }


		//Loop through all envs we have
		mediaEnvs.forEach(function(mediaEnv) {
			//Loop through all filters we have
			mediaFilters.forEach(function(filter) {

				self[mediaEnv.prefix + filter.name] = filter.action(mediaEnv.env);

				switch (envType) {
					case 'angular':
						environment.filter(mediaEnv.prefix + filter.name, function() {
							return filter.action(mediaEnv.env);
						});
						break;
					case 'nunjucks':
						environment.addFilter(mediaEnv.prefix + filter.name, filter.action(mediaEnv.env));
						break;
				}
			});
		});

    };

    /**
     * Get video thumbnail link
     */
    self.getVideoThumb = function(mediaUUID, identifier, returnAsStyle, sizeCode) {
        if (!mediaUUID || !identifier) {
            console.error("Invalid parameters for video thumb, given:", identifier, "uuid:", mediaUUID);
        }

        var videoObj = self.parseVideoURL(identifier);

        var thumb;
        if (videoObj.type) {

            if (!videoObj.id) {
                console.warn("Couldn't read id for video hosted in: ", videoObj.type);
            }
            thumb = getExternalVideoThumb(videoObj.type, videoObj.id);
        }
        else {
            sizeCode = sizeCode || '480P';
            var pngExt = 'png';
            thumb = [identifier + sizeCode + '-00001', pngExt].join('.');
        }

        if (returnAsStyle) {
            thumb = 'background-image: url(' + thumb + ')';
        }

        return thumb;
    };



    /**
     * Get image path from media object or private url
     */
    self.getImageFromPath = function (media, type, sizeCode, mediaEnv) {
        var mediaString = '';
        var imagePath = '';
        var isUrl = false;
        var extension = '';
        if (media && media.path && media.path.indexOf('http') !== 0) {
            if (media.format === 'VIDEO') {
                if (media.is_hosted === true) {
                    return media.path;
                } else {
                    extension = 'mp4';
                    var filename;
                    var base;
                    if (media.status === 'WAITING_TRANSCODING') {
                        filename = 'original';
                        base = publicConfiguration.getMediaServer()
                    } else {
                        filename = '480P';
                        base = publicConfiguration.getTranscodedMediaServer()
                    }
                    imagePath = base + '' + media.path + '' + media.uuid + '/' + filename +'.';
                }
            } else {
                extension = media.file_extension || 'jpeg';
                imagePath = getMediaUrl(mediaEnv) + '' + media.path + '' + media.uuid + '/' + '[SIZE]' + '.';
            }
        } else if (typeof media === 'string') {
            isUrl = true;
            imagePath = media
        }
        // Show default images if hide user profile images
        var showDefault = _isUserProfileImagesHidden && type == 'user_profile';

        if (!showDefault && imagePath) {

            if (!imagePath || !type || !sizeCode) {
                console.error("Invalid parameters for hImagePath, id:", id, "type:", type, "sizeCode:", sizeCode);
            }

            mediaString = imagePath.replace("[SIZE]", getSize(sizeCode));

            if (!isUrl) {
                mediaString += ('' + extension);
            }
        }
        else {
            if (type.indexOf('rectangle') >= 0) {
                mediaString = 'images/rectangle_default.png';
            } else if (sizeCode.indexOf('cover') > -1) {
                mediaString = 'images/default_cover_image.jpg';
            } else if (type.indexOf('brand') >= 0) {
                mediaString = 'images/default_brand_600.png';
            } else if (type.indexOf('carri') >= 0 ) {
                mediaString =  'images/carri/carri-chatbot-logo.png';
            }
            else {
                mediaString =  'images/default_600.png';
            }
        }

        return mediaString;
    };


    /**
     * Get image path from params
     */
    self.getImagePath = function(imageUUID, id, returnAsStyle, sizeCode, type, extension, defaultImage, mediaEnv) {
        var mediaString = '';

        // Show default images if hide user profile images
        var showDefault;
        if (id === currentUserId || mediaEnv === "TEAM_MEDIA_SERVERS") {
            showDefault = false;
        } else {
            showDefault = _isUserProfileImagesHidden && (type == 'user_profile' || type == 'user_background');
        }

        if (!showDefault && imageUUID) {

            if (!id || !type || !sizeCode) {
                console.error("Invalid parameters for hImagePath, id:", id, "type:", type, "sizeCode:", sizeCode);
            }

            var imagesFolder = type.indexOf('brand') == 0  ? 'brands' : 'users';
            var mediaServer = getMediaUrl(mediaEnv);

            var path = imagesFolder + '/' + id + '/' + type + '/';

            if (typeof(id) == 'string' && id.indexOf("/") >= 0) {
                path = id;
            }

            extension = extension || 'jpeg';
            mediaString = mediaServer + path + imageUUID + '/' + getSize(sizeCode) + '.' + extension;
        }
        else {
            if (type === 'user_background') {
                mediaString = defaultImage || 'images/default_user_cover.jpg';
            } else if (sizeCode.indexOf('cover') > -1) {
                mediaString = defaultImage || 'images/default_cover_image.jpg';
            } else if (type.indexOf('brand') >= 0) {
                mediaString = defaultImage || 'images/default_brand_600.png';
            } else if (type.indexOf('carri') >= 0) {
                mediaString = defaultImage || 'images/carri/carri-chatbot-logo.png';
            } else {
                mediaString = defaultImage || 'images/default_600.png';
            }

        }

        if (returnAsStyle) {
            mediaString = 'background-image: url(' + mediaString + ')';
        }

        if (mediaString.includes('/nullnull/240_240.jpeg')) {
            console.error(`invalid media url got: ${mediaString}`);
        }
        
        return mediaString;
    };

    self.hideUserProfileImages = function(isImagesHidden) {

        _isUserProfileImagesHidden = (isImagesHidden === false) ? false : true;
    };

    self.setCurrentUserId = function(userId) {
        currentUserId = userId;
    };

    /**
     * Get video thumbnail from video file
     */

    self.getVideoThumbnail = function (file, currentTime = 0) {
        return new Promise((resolve, reject) => {
            const video = document.createElement('video');
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            const reader = new FileReader();

            reader.onload = (e) => {
                video.src = e.target?.result;

                video.addEventListener('loadeddata', () => {
                    video.currentTime = currentTime;

                    video.addEventListener('seeked', () => {
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        context?.drawImage(video, 0, 0, canvas.width, canvas.height);

                        const thumbnailHref = canvas.toDataURL('image/png');
                        resolve(thumbnailHref);
                    });

                    video.addEventListener('error', () => {
                        reject(new Error('Error generating thumbnail'));
                    });
                });

                video.addEventListener('error', () => {
                    reject(new Error('Error loading video data'));
                });
            };

            reader.onerror = () => {
                reject(new Error('Error reading file'));
            };

            reader.readAsDataURL(file);
        });
    }

    self.base64toBlob = function(base64Data, contentType) {

        base64Data = base64Data.split(',')[1];

        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);

        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }

        var blob;

        try {
            blob = new Blob(byteArrays, { type: contentType });
        }
        catch(e) {
            window.BlobBuilder = window.BlobBuilder ||
                window.WebKitBlobBuilder ||
                window.MozBlobBuilder ||
                window.MSBlobBuilder;

            var newArray = [];

            for (var i in byteArrays) {
                newArray.push(byteArrays.buffer);
            }

            if(e.name == 'TypeError' && window.BlobBuilder){
                var blobBuilder = new BlobBuilder();

                blobBuilder.append(newArray);

                blob = blobBuilder.getBlob(contentType);
            }
            else if(e.name == "InvalidStateError"){
                // InvalidStateError (tested on FF13 WinXP)
                blob = new Blob( newArray, {type : contentType});
            }
            else {
                hAlert("Unsupported Feature", "Your browser doesn't support our image cropper feature.");
                console.warn("Blobs are not supported");
            }
        }

        return blob;
    }

    /**
     * Convert video URL to embeddable format
     * Handles private Vimeo URLs with tokens and standard YouTube/Vimeo URLs
     */
    self.getEmbeddableVideoURL = function(source) {
        if (!source) return source;

        if (source.includes('vimeo.com/') && source.includes('/')) {
            const vimeoMatch = source.match(/vimeo\.com\/(\d+)\/([a-zA-Z0-9]+)/);
            if (vimeoMatch) {
                const videoId = vimeoMatch[1];
                const token = vimeoMatch[2];
                return `https://player.vimeo.com/video/${videoId}?h=${token}&title=0&byline=0&portrait=0`;
            }
        }

        const videoObj = self.parseVideoURL(source);
        if (videoObj.type === 'youtube' && videoObj.id) {
            return `https://www.youtube.com/embed/${videoObj.id}?autoplay=0&rel=0`;
        }
        else if (videoObj.type === 'vimeo' && videoObj.id) {
            return `https://player.vimeo.com/video/${videoObj.id}?title=0&byline=0&portrait=0`;
        }

        return source;
    };
};
//export public configuration to node.js app.
try {
    module.exports = MediaUtils;
} catch (e) { }

if(typeof window != "undefined"){
    window.MediaUtils = MediaUtils;
}
